import { Component } from '@angular/core';
import { IonicPage, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { UserAuthProvider } from '../../modules/mrk-user-auth/user-auth';
import { LoadingController } from 'ionic-angular';
import { User } from '../../models/models';


/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  qty: string;

  formEnabled: boolean;
  isSignup: boolean = false;
  public formCredential: FormGroup;

  constructor(private formBuilder: FormBuilder, private toastCtrl: ToastController, private userAuth: UserAuthProvider<User>, private loading: LoadingController) {
    this.formCredential = this.formBuilder.group({
      full_name: ['',],
      email: ['', Validators.compose([Validators.email, Validators.required])],
      password: ['', Validators.required],
    });
  }

  public login() {
    let l = this.loading.create({
      content: "Attendere.."
    })
    if (!this.formCredential.valid) {
      this.toastCtrl.create({
        message: `Inserisci E-mail e password correttamente`,
        duration: 2000,
        position: 'top'
      }).present();
      return;
    }
    var credential = this.formCredential.value;
    l.present()
    this.userAuth.login(credential.email, credential.password)
      .subscribe(
      _user => {
        l.dismiss()
      },
      _err => {
        l.dismiss()
        this.toastCtrl.create({
          message: `Email o password errate, riprova`,
          duration: 2000,
          position: 'top'
        }).present();
      },
      () => {

      }
      )
  }

  ionViewDidLoad() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts